




import Vue from 'vue'

export default Vue.extend({
    
    props: {
        name:String
    },
    computed: {
        id() : string {
            return "#icon-" + this.name;
        }
    }

})
